import React from "react";
import "./Bottom.css";
const Bottom=()=>{
    return(
        <>
        <div className="bottom-container">
  <h2>STORIES,STYLES AND SPORTSWEAR AT ADIDAS SINCE 1949</h2>
  <p>Sport keeps us fit. Keeps you mindful. Brings us together. Through sport we have the power to change lives.
     Whether it is through stories of inspiring athletes. Helping you to get up and get moving. 
     Sportswear featuring the latest technologies, to up your performance. Beat your PB.
      adidas offers a home to the runner, the basketball player, the soccer kid, the fitness enthusiast. 
      The weekend hiker that loves to escape the city. The yoga teacher that spreads the moves. 
      The 3-Stripes are seen in the music scene. On stage, at festivals.
       Our sports clothing keeps you focused before that whistle blows. 
       During the race. And at the finish lines. 
       We’re here to support creators. Improve their game. Their lives. 
       And change the world.

adidas is about more than sportswear and workout clothes.
 We partner with the best in the industry to co-create.
  This way we offer our fans the sports apparel and style that match their athletic needs, while keeping sustainability in mind.
   We’re here to support creators. Improve their game. Create change. And we think about the impact we have on our world.</p>
        </div>
        <div className="bottom1-container">
 <h3>JOIN ADIDAS AND GET 10% OFF </h3>
 <a href="LoginSignupPopup.js">
  <button>SIGN UP FOR FREE</button>
</a>

        </div>
        </>

    );
};
export default Bottom;